import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Field, FieldArray } from 'redux-form'

import IconButton from 'material-ui/IconButton';

import KeyboardArrowDownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import KeyboardArrowUpIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-up';

import Details from './Details';

import { Checkbox } from 'redux-form-material-ui';

import { changePort } from 'actions/regions/ports';

const styles = {
    checkbox: {
        labelStyle: { fontSize: '14px' },
        style: { width: '90%' }
    },
    icon: {
        iconStyle: { color: '#00bcd4' },
    }
};

class LiftAndCranesItem extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { liftCrane } = this.props;

        return (
            <Fragment>
                <div className='line-head'>
                    <div className='row'>
                        <div className='col-xs-12 middle-xs'>
                            <Field
                                component={Checkbox}
                                name={`liftsCranes.${liftCrane.name}.checked`}
                                label={liftCrane.label}
                                labelStyle={styles.checkbox.labelStyle}
                                style={styles.checkbox.style}
                            />
                        </div>
                    </div>
                </div>

                <div className={'line-body'}>
                    <FieldArray
                        name={`liftsCranes.${liftCrane.name}.details`}
                        component={Details}
                        props={liftCrane}
                        min={liftCrane.name ? parseInt(liftCrane.name.split('-')[0]) : 0}
                        max={liftCrane.name ? parseInt(liftCrane.name.split('-')[1]) : 100}
                    />
                </div>
            </Fragment>
        );
    }
}

LiftAndCranesItem.propTypes = {
    liftCrane: PropTypes.object,
};

LiftAndCranesItem.defaultProps = {
    liftCrane: {},
};

export default connect(
    (state, { liftCrane }) => {
        return { liftCrane };
    },
    dispatch => bindActionCreators({
        changePort,
    }, dispatch),
)(LiftAndCranesItem);



// WEBPACK FOOTER //
// ./app/components/Regions/PortAdd/LiftAndCranes/Item.jsx